<mat-slide-toggle [disabled]="disabled"
                  [color]="color"
                  [ngClass]="classes"
                  [ngModel]="state"
                  (ngModelChange)="updateState($event)">
                  {{label}}
</mat-slide-toggle>
